import { isBefore, startOfDay } from 'date-fns';

interface DatepickerInterval {
  start: Date;
  end: Date;
}

export default function filterIntervalsFromDate(
  intervals: DatepickerInterval[],
  minDate: Date | null | undefined,
): DatepickerInterval[] {
  if (!minDate) return intervals;
  const minDay = startOfDay(minDate);
  return intervals.reduce<DatepickerInterval[]>((acc, interval) => {
    if (isBefore(interval.end, minDay)) return acc;
    if (isBefore(interval.start, minDay)) {
      acc.push({ start: minDay, end: interval.end });
      return acc;
    }
    acc.push(interval);
    return acc;
  }, []);
}
